import { btnDelay } from "common/utils";
import i18n from "features/shared/i18n";
import { ProjectEntity } from "features/player/types";
import { ParentProjectCard } from "./ParentProjectCard";

interface ProjectsSectionProps {
  projects: ProjectEntity[];
  onSelectProject: (project: ProjectEntity) => void;
  onShowMore: () => void;
}

export function ProjectsSection({ projects, onSelectProject, onShowMore }: ProjectsSectionProps) {
  return (
    <div className="bg-white rounded-[16px] p-6">
      <div className="flex-row-el items-center justify-between mb-5 pb-3 border-b border-outline">
        <div className="flex-row-el items-center gap-2 text-[24px] text-textcolor-black">
          <span className="material-symbols-outlined !text-[45px] text-red-100">folder</span>
          {i18n.t("MSG_PARENT_PAGE_PLAYER_PROJECTS")}
          <span className="text-[21px] font-normal text-gray2-100 ml-1">({projects.length})</span>
        </div>
        {projects.length > 5 && (
          <button
            className="flex-row-el items-center gap-1 px-4 py-2 bg-white border border-gray2-60 rounded-full text-[21px] text-textcolor-black cursor-pointer hover:bg-gray2-20 transition-all"
            onClick={() => {
              btnDelay(onShowMore);
            }}
          >
            {i18n.t("MSG_PARENT_PAGE_PLAYER_SHOW_MORE")}
          </button>
        )}
      </div>

      {projects.length > 0 ? (
        <div className="w-full overflow-x-auto invisible-scrollbar">
          <div className="flex-row-el gap-4 pb-2 w-max">
            {projects.slice(0, 5).map((project) => (
              <ParentProjectCard
                key={project.project_id}
                project={project}
                onClick={() => {
                  btnDelay(() => onSelectProject(project));
                }}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="flex-col-center py-8 text-gray2-100">
          <span className="material-symbols-outlined text-[60px] mb-2">folder_open</span>
          <span className="text-[21px]">{i18n.t("MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY")}</span>
        </div>
      )}
    </div>
  );
}
